import { render, staticRenderFns } from "./ChartCarousel.vue?vue&type=template&id=4601065f&scoped=true&"
import script from "./ChartCarousel.vue?vue&type=script&lang=js&"
export * from "./ChartCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ChartCarousel.vue?vue&type=style&index=0&id=4601065f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4601065f",
  null
  
)

export default component.exports